import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppComponent} from './app.component';
import {HomeComponent} from './pages/home/home.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import {LoginComponent} from './pages/login/login.component';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {AppRoutingModule} from './routing.module';
import {ChartsModule} from 'ng2-charts';
import {OverviewComponent} from './components/overview/overview.component';
import {DatePipe, registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {HeizungComponent} from './pages/details/heizung/heizung.component';
import {AddressHeaderComponent} from './components/address-header/address-header.component';
import {OverviewCardComponent} from './components/overview/overview-card/overview-card.component';
import {DetailViewComponent} from './components/detail-view/detail-view.component';
import {DetailHeadlineComponent} from './components/detail-view/detail-headline/detail-headline.component';
import {DetailVerbrauchGraphComponent} from './components/detail-view/detail-verbrauch-graph/detail-verbrauch-graph.component';
import {MatSelectModule} from '@angular/material/select';
import {MatOptionModule} from '@angular/material/core';
import {MenuComponent} from './components/menu/menu.component';
import {WarmwasserComponent} from './pages/details/warmwasser/warmwasser.component';
import {KaltwasserComponent} from './pages/details/kaltwasser/kaltwasser.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {ChangePasswordComponent} from './pages/change-password/change-password.component';
import {EditNotificationsComponent} from './pages/edit-notifications/edit-notifications.component';
import {ActivateAccountComponent} from './pages/activate-account/activate-account.component';
import {MatStepperModule} from '@angular/material/stepper';
import {ResetPasswordComponent} from './pages/reset-password/reset-password.component';
import {ResetPasswordSuccessDialogComponent} from './dialogs/reset-password-success/reset-password-success.dialog.component';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {MatTooltipModule} from '@angular/material/tooltip';
import {HintTooltipComponent} from './components/hint-tooltip/hint-tooltip.component';
import {ResetPasswordConfirmComponent} from './pages/reset-password-confirm/reset-password-confirm.component';
import {LoginWarningDialogComponent} from './dialogs/login-warning/login-warning.dialog.component';
import {LoginCreationErrorDialogComponent} from './dialogs/login-creation-error/login-creation-error.dialog.component';
import {LoginNoMieterDialogComponent} from './dialogs/login-no-mieter/login-no-mieter.dialog.component';

registerLocaleData(localeDe);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    EditNotificationsComponent,
    ChangePasswordComponent,
    ResetPasswordComponent,
    ResetPasswordConfirmComponent,
    ActivateAccountComponent,
    OverviewComponent,
    HeizungComponent,
    WarmwasserComponent,
    KaltwasserComponent,
    AddressHeaderComponent,
    OverviewCardComponent,
    DetailViewComponent,
    DetailHeadlineComponent,
    DetailVerbrauchGraphComponent,
    MenuComponent,
    ResetPasswordSuccessDialogComponent,
    LoginWarningDialogComponent,
    LoginCreationErrorDialogComponent,
    LoginNoMieterDialogComponent,
    HintTooltipComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatCardModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatStepperModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule,
    ChartsModule,
    MatSelectModule,
    MatOptionModule,
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule {
}
